exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".usereditpage-cssmodule-usereditpage-component-21zNM{border:1px dashed red;border:none;padding-top:15px}", ""]);

// exports
exports.locals = {
	"usereditpage-component": "usereditpage-cssmodule-usereditpage-component-21zNM"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/Users/usereditpage.cssmodule.scss
// module id = 612
// module chunks = 0